// Set per environment in .env.development (local), .env.uat and .env.prod
export default () => {
	return (
		process.env.REACT_APP_API_URL ||
		"https://chinapress-cloud-staging.navarch.app/api"
	);
};
